import { Component } from '@theme/component';
import { inView } from 'motion';

/**
 * A custom element that manages anchor links.
 */
export class AnchorLinksComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('DOMContentLoaded', this.#handleDOMContentLoaded);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('DOMContentLoaded', this.#handleDOMContentLoaded);
  }

  #handleDOMContentLoaded = () => {
    const anchorBlocks = document.querySelectorAll('.apc-anchor-block');

    this.innerHTML = Array.from(anchorBlocks)
      ?.map(
        (anchorBlock, index) => `
      <a href="#${anchorBlock.id}" ${index === 0 ? 'data-current' : ''}>${anchorBlock.dataset.title}</a>
    `,
      )
      .join('');

    const anchors = this.querySelectorAll('a[href^="#"]');
    const sections = Array.from(anchorBlocks).map((anchorBlock) => anchorBlock.closest('section'));
    const margin = Math.floor(
      window.innerHeight - 8.375 * parseFloat(getComputedStyle(document.documentElement).fontSize),
    );

    inView(
      /** @type {Element[]} */ (Array.from(sections)),
      (block) => {
        const anchorBlock = block.querySelector('.apc-anchor-block');
        const anchor = Array.from(anchors).find((a) => a.hash === `#${anchorBlock?.id}`);

        if (anchor) {
          anchors.forEach((a) => a.removeAttribute('data-current'));
          anchor.toggleAttribute('data-current', true);
        }

        return () => {};
      },
      { margin: `0px 0px -${margin}px 0px`, amount: 'some' },
    );
  };
}

if (!customElements.get('anchor-links-component'))
  customElements.define('anchor-links-component', AnchorLinksComponent);
